import { TextKey } from '@mews-commander/enums';
import { ContentCard } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { WithScope } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { getUnassignedCompanionships } from '@mews-commander/legacy-entities/src/ducks/companionships';
import { Companionship } from '@mews-commander/data-access';
import { UnassignedCompanionsListItemContainer } from './UnassignedCompanionsListItem';

interface UnassignedCompanionsListProps extends WithScope {
    onSuccess?: () => void;
    unassignedCompanionships: Companionship[];
}

export const UnassignedCompanionsListContainer = ({
    scope,
    onSuccess,
}: Omit<UnassignedCompanionsListProps, 'unassignedCompanionships'>) => {
    const unassignedCompanionships = useCommanderSelector((state) =>
        getUnassignedCompanionships(state, { groupId: scope })
    );

    return (
        <UnassignedCompanionsList
            scope={scope}
            onSuccess={onSuccess}
            unassignedCompanionships={unassignedCompanionships}
        />
    );
};

const UnassignedCompanionsList = ({ scope, onSuccess, unassignedCompanionships }: UnassignedCompanionsListProps) => {
    if (unassignedCompanionships.length === 0) return null;

    return (
        <ContentCard title={lt(TextKey.UnassignedCompanions)}>
            <Stack vertical spacing="100">
                {unassignedCompanionships.map((companionship) => (
                    <UnassignedCompanionsListItemContainer
                        companionship={companionship}
                        scope={scope}
                        onSuccess={onSuccess}
                        key={companionship.id}
                    />
                ))}
            </Stack>
        </ContentCard>
    );
};
